<template>
  <cool-select :list="counterparties"
               option-value="id"
               option-text="value"
               :isError="isError"
               :isDisabled="isDisabled"
               :placeholder="$t('CONTENT.choose')"
               v-model="currentLessorId">
  </cool-select>
</template>

<script>
	import {mapGetters} from 'vuex';

	export default {
    props: {
			lessorIndex: {
				type: Number,
      },
			lessor: {
				required: true,
      },
      isError: {
			  type: Boolean
      },
      isDisabled: {
			  type: Boolean,
        default: false
      },
      hiddenLessorIds: {
        type: Array,
        default: []
      }
    },
		data() {
			return {
				isAutoBindDataLessor: false,
        lessorVal: null,
			}
		},
    created() {
      this.lessorVal = this.lessor;
    },
    watch: {
      lessor(newVal) {
        this.lessorVal = newVal;
      }
    },
    computed: {
			...mapGetters(['getCounterpartiresForContract']),
      counterparties() {
        return this.getCounterpartiresForContract
          .filter(counterparty => !this.hiddenLessorIds.includes(counterparty.id) || counterparty.id === this.currentLessorId)
      },
      currentLessorId: {
        get() {
          if(this.lessorVal === '' || this.lessorVal === null) {
            return null;
          } else {
            return this.lessorVal;
          }
        },
        set(newVal) {
          this.lessorVal = +newVal;
          this.$store.commit('UPDATE_LESSOR', {value: +newVal, index: this.lessorIndex});
          this.$emit('selectLessor', newVal);
        }
      },
    },
	}
</script>
